import * as React from "react";

import {Icon, SemanticICONS, Step} from "semantic-ui-react";

export enum EStepTab {
    ActionTab,
    SummaryTab,
    ConfirmTab,
    ResultTab
}

export type StepTab = {
    step: EStepTab;
    icon: SemanticICONS;
    title: string;
};

export const stepTabList: StepTab[] = [
    {
        step: EStepTab.ActionTab,
        icon: 'pencil',
        title: 'PSL_WF_S_MULTI:ACTION_TAB_TT'
    },
    {
        step: EStepTab.SummaryTab,
        icon: 'tasks',
        title: 'PSL_WF_S_MULTI:SUMMARY_TAB_TT'
    },
    {
        step: EStepTab.ConfirmTab,
        icon: 'checkmark',
        title: 'PSL_WF_S_MULTI:CONFIRM_TAB_TT'
    },
    {
        step: EStepTab.ResultTab,
        icon: 'info',
        title: 'PSL_WF_S_MULTI:RESULT_TAB_TT'
    }
];

export interface StepHeaderProps {
    activeTab: EStepTab;
    steps: StepTab[];
    t: reactI18Next.TranslationFunction;
}

export const StepHeader = (props: StepHeaderProps) => (
    <Step.Group size={'mini'} className={'width--100Percent'}>
        {props.steps.map((item) =>
            <Step key={item.step} active={props.activeTab === item.step}>
                <Icon name={item.icon} />
                <Step.Content>
                    <Step.Title>{props.t(item.title)}</Step.Title>
                </Step.Content>
            </Step>
        )}
    </Step.Group>
);



// WEBPACK FOOTER //
// ./src/views/OptionsView/workflowStatusMultiUpdate/WSMUUtils.tsx